import React from "react";
import {
  TextField,
  FlatButton,
  RaisedButton,
  Checkbox,
  AutoComplete
} from "material-ui";

import BaseOverlay from "./base.jsx";

import CreditCardEntry from "../credit-card-entry.jsx";
import WorkingIndicator from "../working-indicator.jsx";
import LinkLike from "../link-like.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../../stores/PersonStore";
import PersonActions from "../../../actions/PersonActions";
import UserStore from "../../../stores/UserStore";

class EditPersonOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone_number: "",
      mailing_address: "",
      do_not_email: false,
      payments_token: null,
      isEditingPayment: false,
      isSubmittingPayment: false
    };

    this.edit = this.edit.bind(this);
    this.submitPayment = this.submitPayment.bind(this);
    this.clearPayment = this.clearPayment.bind(this);
    this.onAutocompleteInput = this.onAutocompleteInput.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return {
      getPeople: PersonStore.getPeople
    };
  }

  componentDidMount() {
    if (this.props.isNew) {
      PersonActions.fetchAll.defer();
    }
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    if (props.details) {
      this.setState({
        name: props.details.name,
        email: props.details.email,
        phone_number: props.details.phone_number,
        mailing_address: props.details.mailing_address,
        do_not_email: props.details.do_not_email,
        payments_token: null,
        payment_method_summary: props.details.payment_method_summary,
        isEditingPayment: false,
        isSubmittingPayment: false,
        paymentErrorMessage: null
      });
    }

    if (props.isNew) {
      this.setState({
        autocompletePeople: props.getPeople().map(p => {
          return {
            value: p,
            text: `${p.details.email}${
              p.details.name ? ` (${p.details.name})` : ""
            }`
          };
        })
      });
    }
  }

  submitPayment() {
    this.setState({
      isSubmittingPayment: true
    });
    Stripe.card.createToken(
      this.refs.cardEntry.getPaymentDetails(),
      (status, response) => {
        if (response.error) {
          this.setState({
            isSubmittingPayment: false,
            paymentErrorMessage: response.error.message
          });
        } else {
          if (this.props.isNew) {
            this.setState({
              payments_token: response.id,
              isEditingPayment: false,
              isSubmittingPayment: false,
              payment_method_summary: "Ready to save"
            });
          } else {
            this.props.onEdit(
              {
                payments_token: response.id
              },
              { doNotClose: true }
            );
          }
        }
      }
    );
  }

  clearPayment() {
    this.props.onEdit(
      {
        clear_payments_info: true
      },
      { doNotClose: true }
    );
  }

  edit() {
    let {
      name,
      email,
      phone_number,
      mailing_address,
      do_not_email,
      payments_token
    } = this.state;
    this.props.onEdit(
      {
        name,
        email,
        phone_number,
        mailing_address,
        do_not_email,
        payments_token
      },
      { existingId: this.state.existingPerson && this.state.existingPerson.id }
    );
  }

  onAutocompleteInput(raw) {
    if (raw && raw.value) {
      this.selectPerson(raw.value);
    } else {
      this.setState({ email: raw });
    }
  }

  selectPerson(person) {
    this.setState({
      existingPerson: person,
      name: person.details.name,
      email: person.details.email,
      phone_number: person.details.phone_number,
      mailing_address: person.details.mailing_address,
      do_not_email: person.details.do_not_email,
      payment_method_summary: person.details.payment_method_summary
    });
  }

  render() {
    let { onRequestClose, isNew, details } = this.props,
      { name, email, do_not_email, payment_method_summary, existingPerson } =
        this.state;

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Cancel" onTouchTap={onRequestClose} />,
          <FlatButton
            primary={true}
            label={isNew && !existingPerson ? "Create person" : "Save changes"}
            onTouchTap={this.edit}
          />
        ]}
      >
        {!isNew || existingPerson ? (
          <div>
            Your changes will affect the customer's entire account.{" "}
            {isNew ? (
              <LinkLike
                onTouchTap={() => {
                  this.setState({
                    existingPerson: null,
                    name: "",
                    email: "",
                    mailing_address: "",
                    payments_token: null,
                    payment_method_summary: null
                  });
                }}
              >
                Reset
              </LinkLike>
            ) : null}
          </div>
        ) : (
          <div>
            After creation, the new customer will receive an email with a link
            to set their password.
          </div>
        )}
        {details && details.sundance_user_id && !UserStore.isGod() ? (
          <div style={{ marginTop: "1em" }}></div>
        ) : (
          <div style={{ marginTop: "1em" }}>
            {isNew ? (
              <AutoComplete
                floatingLabelText="Customer email address*"
                floatingLabelFixed={true}
                dataSource={this.state.autocompletePeople || []}
                searchText={this.state.email}
                filter={(searchText, key) =>
                  searchText &&
                  key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
                }
                maxSearchResults={5}
                menuProps={{ desktop: true, autoWidth: true, width: "auto" }}
                style={{ width: 256, display: "inline-block" }}
                textFieldStyle={{ width: 256 }}
                fullWidth={true}
                onNewRequest={this.onAutocompleteInput}
                onUpdateInput={this.onAutocompleteInput}
              />
            ) : (
              <TextField
                value={this.state.email}
                floatingLabelText="Customer email address"
                floatingLabelFixed={true}
                onChange={e => this.setState({ email: e.target.value })}
              />
            )}
            <TextField
              value={this.state.name}
              floatingLabelText="Customer name"
              floatingLabelFixed={true}
              style={{ marginLeft: "1em" }}
              onChange={e => this.setState({ name: e.target.value })}
            />
          </div>
        )}
        <div
          style={{
            marginTop: "-0.5em",
            marginBottom:
              (this.state.mailing_address || "").indexOf("\n") !== -1
                ? "2em"
                : 0
          }}
        >
          <TextField
            value={this.state.phone_number}
            floatingLabelText="Customer phone number"
            floatingLabelFixed={true}
            onChange={e => this.setState({ phone_number: e.target.value })}
          />
          <div
            style={{
              marginLeft: "1em",
              display: "inline-block",
              position: "absolute"
            }}
          >
            <TextField
              style={{ textAlign: "left" }}
              floatingLabelText="Customer mailing address"
              floatingLabelFixed={true}
              rowsMax={2}
              multiLine={true}
              value={this.state.mailing_address}
              onChange={e => this.setState({ mailing_address: e.target.value })}
            />
          </div>
        </div>
        <div style={{ marginTop: "1em" }}>
          <Checkbox
            label={"Unsubscribe from promotional emails"}
            checked={this.state.do_not_email}
            onCheck={() =>
              this.setState({ do_not_email: !this.state.do_not_email })
            }
          />
        </div>
        <div style={{ marginTop: "1em" }}>
          {this.state.isEditingPayment ? (
            <div>
              <CreditCardEntry
                style={{ maxWidth: 620, marginTop: -20, marginBottom: 12 }}
                ref="cardEntry"
              />
              {this.state.paymentErrorMessage ? (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.75em",
                    marginBottom: "0.5em"
                  }}
                >
                  {this.state.paymentErrorMessage}
                </div>
              ) : null}
              <RaisedButton
                primary={true}
                label={
                  this.state.isSubmittingPayment
                    ? "Updating payment method"
                    : "Update payment method"
                }
                disabled={this.state.isSubmittingPayment}
                onTouchTap={() => this.submitPayment()}
              />
              {payment_method_summary ? (
                <RaisedButton
                  style={{ marginLeft: 7 }}
                  label={`Delete saved payment method`}
                  onTouchTap={() => this.clearPayment()}
                />
              ) : null}
              <RaisedButton
                style={{ marginLeft: 7 }}
                label="Cancel"
                onTouchTap={() => this.setState({ isEditingPayment: false })}
              />
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: 5 }}>
                Current payment method:{" "}
                <strong>{payment_method_summary || "None specified"}</strong>
              </div>
              <RaisedButton
                label="Edit payment method"
                onTouchTap={() => this.setState({ isEditingPayment: true })}
              />
            </div>
          )}
        </div>
      </BaseOverlay>
    );
  }
}

export default connectToStores(EditPersonOverlay);



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/edit-person.jsx